import { ApiClient } from './ApiClient';
import type { PaymentTrackingQuery, PaymentTrackingDto, ApiResponse } from './PaymentTrackingTypes';

export class ApiClientExtended extends ApiClient {
    /**
     * Download file dạng blob từ API endpoint
     */
    async downloadBlob(url: string, method: string = "GET", data?: any): Promise<Blob> {
        const response = await this.instance.request({
            method,
            url: this.baseUrl + url,
            data: data ? JSON.stringify(data) : undefined,
            headers: data ? { "Content-Type": "application/json" } : undefined,
            responseType: "blob",
        });
        return new Blob([response.data]);
    }

    /**
     * Lấy thống kê tiến trình nộp học phí
     */
    async receiptGetPaymentTracking(query: PaymentTrackingQuery): Promise<ApiResponse<PaymentTrackingDto>> {
        const url = this.baseUrl + "/api/v1/receipt/payment-tracking";
        
        const options = {
            method: "POST",
            url: url,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            data: JSON.stringify(query)
        };

        try {
            const response = await this.instance.request(options);
            return response.data;
        } catch (error) {
            console.error("Error calling receiptGetPaymentTracking:", error);
            throw error;
        }
    }
} 